import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import Translator from "Languages/Utility/Translator";
import Grid from "@material-ui/core/Grid";
import Input from "Components/Input/Input";
import MuiButton from "Components/MuiButton/MuiButton";
import * as R from "ramda";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import MuiCheckBoxGroup from "Components/MuiCheckboxGroup/MuiCheckboxGroup";
import SettingService from "Services/http/endpoints/setting/SettingService";
import StatusHandler from "Helpers/StatusHandler";
import { useTranslation } from "react-i18next";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import * as Icons from "react-bootstrap-icons";

function FormTarahi(props) {
  const { t } = useTranslation();
  const { settingDesignData } = useSelector((state) => ({
    settingDesignData: state.setting.settingDesignData,
  }));
  const [loading, setLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [formValid, setFormValid] = useState({});

  const [controls, setControls] = useSetState({
    unitName: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
    },
    breakW: {
      type: "text",
      value: "",
      endIcon: "millimeter",
      validation: {
        required: true,
      },
    },
    breakH: {
      type: "text",
      value: "",
      endIcon: "millimeter",
      validation: {
        required: true,
      },
    },
    sizeFontDesigner: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
    },
    limitCouple: {
      type: "text",
      value: "",
      endIcon: "millimeter",
      validation: {
        required: true,
      },
    },
    limitMulion: {
      type: "text",
      value: "",
      endIcon: "millimeter",
      validation: {
        required: true,
      },
    },
    limitGuidLine: {
      type: "text",
      value: "",
      endIcon: "millimeter",
      validation: {
        required: true,
      },
    },
    handlePlace: {
      type: "text",
      value: "",
      endIcon: "millimeter",
      validation: {
        required: true,
      },
    },
    railChannelCoverProfile: {
      type: "checkbox",
      items: [
        { value: false, key: "ZehvarBaranTowRail" },
        { value: false, key: "ZehvarBaranOneRail" },
        { value: false, key: "ZehvarBaranFixOneRail" },
        { value: false, key: "ZehvarBaranBottom" },
        { value: false, key: "ZehvarBaranAll" },
      ],
    },
  });
  const onShowDialog = () => {
    setShowDialog(!showDialog);
  };
  const onFinish = async (e) => {
    e.preventDefault();
    const {
      unitName,
      breakW,
      breakH,
      sizeFontDesigner,
      limitCouple,
      limitMulion,
      limitGuidLine,
      railChannelCoverProfile,
      handlePlace,
    } = controls;

    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      try {
        setLoading(true);
        let data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          BreakH: +convertToEnglishNumber(breakH.value),
          BreakW: +convertToEnglishNumber(breakW.value),
          LimitCouple: +convertToEnglishNumber(limitCouple.value),
          LimitGuidLine: +convertToEnglishNumber(limitGuidLine.value),
          LimitMulion: +convertToEnglishNumber(limitMulion.value),
          NameUnit: unitName.value,
          SizeFontDesigner: +convertToEnglishNumber(sizeFontDesigner.value),
          Handle: +convertToEnglishNumber(handlePlace.value),
        };
        railChannelCoverProfile.items.map((item) => {
          data = {
            ...data,
            [item.key]: item.value,
          };
        });

        const response = await SettingService.postSettingDesign(data);
        let err = StatusHandler(response);
        if (!err.isFail) {
          showNotify({
            text: t("design_setting_done"),
            customClass: "success",
          });
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
      onShowDialog();
    } else {
      showNotify({
        text: t("correctFormDataRequired"),
        customClass: "error",
      });
    }
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const onChangeCheckbox = (e, name, index) => {
    const items = controls[name].items;
    items[index] = { ...items[index], value: e.currentTarget.checked };
    setControls({ [name]: { items: items } });
    setFormValid((prev) => ({ ...prev, [name]: true }));
  };

  const onChangeCheckbox_SelectAll = (e, name) => {
    setControls({
      [name]: {
        items: controls[name].items.map((inner) => {
          inner.value = true;
          return inner;
        }),
      },
    });
    setFormValid((prev) => ({ ...prev, [name]: true }));
  };

  useEffect(() => {
    if (settingDesignData) {
      setControls({ unitName: { value: settingDesignData.NameUnit } });
      setControls({ breakW: { value: settingDesignData.BreakW } });
      setControls({ breakH: { value: settingDesignData.BreakH } });
      setControls({
        sizeFontDesigner: { value: settingDesignData.SizeFontDesigner },
      });
      setControls({ limitCouple: { value: settingDesignData.LimitCouple } });
      setControls({ limitMulion: { value: settingDesignData.LimitMulion } });
      setControls({
        limitGuidLine: { value: settingDesignData.LimitGuidLine },
      });
      setControls({
        handlePlace: { value: settingDesignData.Handle },
      });
      const items = controls.railChannelCoverProfile.items;
      items.map((item, index) => {
        items[index] = { ...items[index], value: settingDesignData[item.key] };
      });
      setControls({ railChannelCoverProfile: { items: items } });
      const validation_data = {};
      Object.keys(controls)
        .filter((key) => controls[key].type !== "checkbox")
        .map((key) => {
          validation_data[key] =
            controls[key].value !== null || controls[key].value !== ""
              ? true
              : false;
        });
      setFormValid(validation_data);
    }
  }, [settingDesignData]);

  return (
    <Grid container spacing={2}>
      {Object.keys(controls).map((key, index) => {
        if (controls[key].type === "text") {
          return (
            <Grid item lg={2} md={3} sm={6} xs={12} key={key + index}>
              <Input
                loading={props.loading}
                setValue={setValue.bind(this)}
                name={key}
                validation={controls[key].validation}
                label={<Translator id={key} />}
                value={controls[key].value}
                type="text"
                endIcon={
                  controls[key].endIcon && (
                    <Translator id={controls[key].endIcon} />
                  )
                }
                disabled={loading}
              />
            </Grid>
          );
        }
      })}
      {Object.keys(controls).map((key, index) => {
        if (controls[key].type === "checkbox") {
          return (
            <Grid item xs={12} key={key + index}>
              <MuiCheckBoxGroup
                label={<Translator id={key} />}
                name={key}
                value={controls[key].value}
                items={controls[key].items}
                onChange={onChangeCheckbox}
                className="horizontalCheckbox"
                selectAllShow
                onSelectAll={onChangeCheckbox_SelectAll}
                translate={true}
                disabled={loading}
              />
            </Grid>
          );
        }
      })}

      <Grid item xs={12} className="d-flex justify-content-end my-4">
        <MuiButton
          loading={loading}
          color="primary"
          title={<Translator id="zakhire_tanzimat_tarahi" />}
          innerIcon={<Icons.Floppy />}
          onClick={onFinish}
          fullwidthOnSm
        />
      </Grid>
    </Grid>
  );
}

export default FormTarahi;
